import React, { Component } from 'react';
import {
  Container, Typography
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

// Redux
import { connect } from 'react-redux';
import { clearErrors } from '../../../../redux/actions/alertActions';

// Components
import FloorForm from '../../../../components/FloorForm';

// Constants
import { DEFAULT } from '../../../../constants';

class CreateFloor extends Component {

  constructor(props) {
    super(props);

    this.state = {
      redirectToFloor: false
    };
  }

  componentWillUnmount() {
    this.props.clearErrors();
  }

  render() {
    return this.state.redirectToFloors || !this.props.setupMode ? <Redirect to='/admin/floors' /> : (
      <Container style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Typography variant='h1'>Add a Floor</Typography>
        <FloorForm onSuccess={() => this.setState({ redirectToFloors: true })} />
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  statusColor: state.status.schoolStatus ? state.status.schoolStatus.getColor() : DEFAULT,
  isMobile: state.ui.isMobile,
  isFullWidth: state.ui.isFullWidth,
  setupMode: state.setupMode.mode || state.setupMode.isLoading
});

const mapDispatchToProps = dispatch => ({
  clearErrors: () => dispatch(clearErrors())
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateFloor);

CreateFloor.propTypes = {
  clearErrors: PropTypes.func,
  statusColor: PropTypes.object,
  isMobile: PropTypes.bool,
  isFullWidth: PropTypes.bool,
  setupMode: PropTypes.setupMode
};
